export const instrumentationKey = '37e4e69a-721d-4120-a3b8-ca352edfa703';
export const connectionString = `InstrumentationKey=${instrumentationKey};IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/`;
